const INITIAL_STATE = [{ hasExams: false }];

export default function (state = INITIAL_STATE, action = []) {
    if (action.type === 'HAS_EXAMS') {
        return [{ hasExams: true }]
    }

    if (action.type === 'NO_EXAMS') {
        return [{ hasExams: false }]
    }

    return state
}